/**
 *
 * @returns HTMLElement | undefined
 * @description Attempts to find the first h1[tabindex="-1"].
 *
 * Some rarepages don't have an <h1>, so we fallback to the body id "top" and focus the first focusable element.
 */
export const getFirstFocusableElementInMain = (): HTMLElement | undefined => {
  const main = document.getElementById('content');
  const focusableElements = main?.querySelectorAll('h1[tabindex="-1"]');

  if (!focusableElements || focusableElements.length === 0) {
    const alternateMain = document.querySelector('body');
    const alternateElements = alternateMain?.querySelectorAll('button, [href], input, select, textarea');
    if (!alternateElements || alternateElements.length === 0) {
      return undefined;
    }

    return alternateElements[0] as HTMLElement;
  }

  return focusableElements[0] as HTMLElement;
};
